export var AccountTrainingProject;
(function (AccountTrainingProject) {
    AccountTrainingProject["Retail"] = "retail";
    AccountTrainingProject["Fsi"] = "fsi";
    AccountTrainingProject["Travel"] = "travel";
})(AccountTrainingProject || (AccountTrainingProject = {}));
//# sourceMappingURL=account.training.project.js.map